import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Cache module-level para /api/config/public: la home + SiteFooter + otros
// componentes lo consumen simultáneamente. Sin este cache haríamos varias
// llamadas duplicadas en cada montaje.
let _cache = null;
let _promise = null;

function fetchConfig() {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = api.get("/config/public")
      .then((r) => { _cache = r.data || {}; return _cache; })
      .catch(() => ({}));
  }
  return _promise;
}

export function usePublicConfig() {
  const [config, setConfig] = useState(_cache);
  useEffect(() => {
    let mounted = true;
    fetchConfig().then((c) => { if (mounted) setConfig(c); });
    return () => { mounted = false; };
  }, []);
  return config || {};
}
